var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoanOfficerLoaded)?_c('div',[_c('div',{staticClass:"text-h5 text-center mb-4"},[_vm._v("You have been invited by: "),_c('div',{staticClass:"text-h5 mx-8 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.loanOfficer.firstName)+" "+_vm._s(_vm.loanOfficer.lastName)+" ")])]),_c('ApplicationForm')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }